// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-model .v-input input[data-v-3cb0bd84]{text-align:center!important}.keypad-column[data-v-3cb0bd84]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:90px}.keypad-column[data-v-3cb0bd84] .v-btn{font-size:1.275rem}.keypad-column[data-v-3cb0bd84] .v-btn:before{background-color:unset!important}", ""]);
// Exports
module.exports = exports;
